import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import Responsive from 'src/_context/Responsive';
import { InjectedTransitionedContainerProps, withTransitionedContainer } from 'src/_context/TransitionedContainer';
import responsive from 'src/constants/responsive';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';

export type MenuProps = {};
const styles = {
    nav: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    link: {
        pointerEvents: 'initial',
        [responsive.Mobile]: {
            marginBottom: 5,
            color: '#000'
        }
    },
    lagNav: {
        ...stylesheet.PaddingGutter(.5, directions.top)
    },
    lagNavMobile: {
        lineHeight: '1.5 !important',
        color: '#000',
        display: 'block'
    },
    langNav: {
        marginRight: 5,
        ...stylesheet.SmallText,
        pointerEvents: 'initial'
    },
    active: {
        [responsive.AfterMobile]: {
            color: 'black'
        }
    }
};

type Props =
    MenuProps &
    InjectedApiProps &
    RouteComponentProps<any> &
    InjectedTransitionedContainerProps &
    StyledComponentProps<keyof typeof styles>;
type State = {};

export class Menu extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this._toPage = this._toPage.bind(this);
    }

    render() {
        const { classes, apiCtx: { app } } = this.props;
        return (
            <nav className={classes!.nav}>
                {app && app.Menus.map((menu) =>
                    <NavLink
                        key={menu.UID}
                        to={`/${Language}/${menu.UID}`}
                        className={classes!.link}
                        activeClassName={classes!.active}
                        onClick={this._toPage}
                        data-routed="true"
                    >
                        {menu.Title}
                    </NavLink>)}
                <nav className={classes!.lagNav}>
                    <Responsive.Consumer steps={["AfterMobile"]}>
                        <a
                            href={`?switch-lang=fr`}
                            className={classNames(classes!.langNav, Language === "fr" ? classes!.active : '')}
                            data-routed="true"
                        >
                            FR
                        </a>
                        <a
                            href={`?switch-lang=en`}
                            className={classNames(classes!.langNav, Language === "en" ? classes!.active : '')}
                            data-routed="true"
                        >
                            EN
                        </a>
                    </Responsive.Consumer>
                    <Responsive.Consumer steps={["Mobile"]}>
                        <a
                            href={`?switch-lang=fr`}
                            className={
                                classNames(
                                    classes!.langNav,
                                    classes!.lagNavMobile,
                                    Language === "fr" ? classes!.active : '')}
                            data-routed="true"
                        >
                            Français
                        </a>
                        <a
                            href={`?switch-lang=en`}
                            className={
                                classNames(
                                    classes!.langNav,
                                    classes!.lagNavMobile,
                                    Language === "en" ? classes!.active : '')}
                            data-routed="true"
                        >
                            English
                        </a>
                    </Responsive.Consumer>
                </nav>
            </nav>
        );
    }
    private _toPage() {
        const { transitionedContainer: { move } } = this.props;

        move('pages')
    }
}

export default withTransitionedContainer(withRouter(withApi(withStyles(styles)(Menu))));


// WEBPACK FOOTER //
// ./src/components/Menu.tsx